const PlanningCancellationDecisionEnum = {
  BareDecision: 'BareDecision',
  ClientDecision: 'ClientDecision',
  Other: 'Other',
};

export default PlanningCancellationDecisionEnum;
